var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_7",
  "data-name": "Ellipse 7",
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#1370fc"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_3531",
  "data-name": "Group 3531",
  transform: "translate(-360 -1280)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3473",
  "data-name": "Group 3473",
  transform: "translate(368 1292)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3472",
  "data-name": "Group 3472",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M23.847,100.347c-.214-.307-5.323-7.512-11.848-7.512S.366,100.04.152,100.346a.859.859,0,0,0,0,.977c.214.307,5.323,7.512,11.848,7.512s11.633-7.205,11.848-7.511A.858.858,0,0,0,23.847,100.347ZM12,107.18c-4.806,0-8.969-4.782-10.2-6.345C3.03,99.27,7.184,94.49,12,94.49s8.968,4.781,10.2,6.345C20.97,102.4,16.816,107.18,12,107.18Z",
  transform: "translate(0 -92.835)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3475",
  "data-name": "Group 3475",
  transform: "translate(374.975 1294.975)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3474",
  "data-name": "Group 3474",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_88",
  "data-name": "Path 88",
  d: "M159.747,154.725a5.025,5.025,0,1,0,5.025,5.025A5.031,5.031,0,0,0,159.747,154.725Zm0,8.376a3.35,3.35,0,1,1,3.35-3.35A3.354,3.354,0,0,1,159.747,163.1Z",
  transform: "translate(-154.722 -154.725)",
  fill: "#fff"
}))))));
export default __webpack_public_path__ + "static/media/image-eye.e2479f23.svg";
export { SvgComponent as ReactComponent };